import Vue from 'vue'
import App from './App.vue'
import router from "./router/index";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret,faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret,faArrowLeft)

Vue.component('font-awesome-icon', FontAwesomeIcon)


// 表格
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
Vue.use(VXETable)
VXETable.use(VXETablePluginExportXLSX)



Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
